import React from "react";

const CancelSvg = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12.829"
        height="12.828"
        viewBox="0 0 12.829 12.828"
      >
        <g
          id="Group_74356"
          data-name="Group 74356"
          transform="translate(-5.586 -5.586)"
        >
          <path
            id="Path_1141"
            data-name="Path 1141"
            d="M17,7,7,17"
            transform="translate(0 0)"
            fill="none"
            stroke="#111"
            stroke-linecap="round"
            stroke-linejoin="round"
            strokeWidth="2"
          />
          <path
            id="Path_1142"
            data-name="Path 1142"
            d="M17,17,7,7"
            transform="translate(0 0)"
            fill="none"
            stroke="#111"
            stroke-linecap="round"
            stroke-linejoin="round"
            strokeWidth="2"
          />
        </g>
      </svg>
    </>
  );
};

export { CancelSvg };
